import { cpf } from 'cpf-cnpj-validator'

import type { ICPFValidator } from './cpf-validator'

export class CPFValidatorAdapter implements ICPFValidator {
  format(input: string) {
    return cpf.format(input)
  }

  parse(input: string) {
    return cpf.strip(input, false)
  }

  isValid(input: string) {
    return cpf.isValid(input)
  }
}
